import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useEffect, useState, Fragment } from "react";
import axios from "axios";
import { baseURL } from "../../constants/Api";
import BgHotelguide from "../../images/hotelguideBg.png";
import BackButton from "../bars/BackButton";
import Skeleton from "../../components/skeletons/skeleton";
import Emty from "../../components/emty-state/Emty";
import { HotelGuidePageView } from "../../utils/Analytics";

function Hotelguide() {
  const navigate = useNavigate();
  const location = useLocation();
  const [hotelGuideData, SethotelGuideData] = useState([]);
  const currenturl = window.location.href;
  const urlArray = currenturl.split("/");
  const hotelId = urlArray[urlArray.length - 1];
  const [loading, setLoading] = useState(false);
  const [emty, setEpty] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    const getHotelGuide = async () => {
      setLoading(true);
      try {
        await axios({
          method: "post",
          url: `${baseURL}/api/hotelGuide`,
          data: {
            hotelId: hotelId,
            type: "0",
          },
          headers: { "Content-Type": "application/json" },
        }).then(function (response) {
          SethotelGuideData(response.data.data);
          if (response.data.data.length === 0) {
            setEpty(true);
          }
          setLoading(false);
        });
      } catch {
        setLoading(false);
      }
    };
    getHotelGuide();
  }, []);
  
   useEffect(() => {
      HotelGuidePageView();
     }, []);

  return (
    <div>
      {!loading ? (
        <div>
          <div className="mb-28 relative">
            <div
              style={{
                width: "100%",
                height: "150px",
                maxHeight: "200px",
                backgroundImage: `url(${BgHotelguide})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            ></div>
            <div className="absolute top-3 left-3">
              <BackButton whiteTheme={true}  />
            </div>
            <div className="section-wrap mx-4 pt-6">
              <div className="guestName sm:text-center text-left">
                Hotel Guides
              </div>
              <div>
                <div className="gridTab grid grid-flow-row grid-cols-2 gap-3 gap-x-4 mt-3">
                  {hotelGuideData.map((hotelGuideData, index) => (
                    <Link
                      to={"/hotel-guide-detail/" + hotelGuideData.id}
                      state={hotelGuideData}
                      key={index}
                      className="flex flex-col p-2 w-full bg-[#342F4F] rounded-md  hover:shadow-lg  transition-all"
                    >
                      <div className="w-full  flex justify-center items-stretch bg-gray-200 rounded-md overflow-hidden h-[106px] sm:h-[160px] ">
                        <img
                          width="100%"
                          height="100%"
                          className="flex items-stretch bg-contain object-cover transition w-full h-full"
                          src={hotelGuideData.image}
                          alt="hotelGuide"
                        ></img>
                      </div>
                      <div className=" mt-2 sm:text-base text-[14px] truncate font-medium pb-2">
                        {hotelGuideData.name}
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            {emty && <Emty item="Hotel guides" />}
          </div>
        </div>
      ) : (
        <Skeleton type="page" />
      )}
    </div>
  );
}

export default Hotelguide;
